/* eslint-disable react/no-array-index-key */
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';

const PREFIX = 'ListSkeleton';

const classes = {
  skeleton: `${PREFIX}-skeleton`,
};

const Root = styled('div')((
  {
    theme,
  },
) => ({
  [`& .${classes.skeleton}`]: {
    marginTop: theme.spacing(1),
  },
}));

interface ListSkeletonProps {
  numberOfListItems: number;
}

const ListSkeleton = ({ numberOfListItems }: ListSkeletonProps) => (
  <Root>
    { Array.from(Array(numberOfListItems).keys()).map(
    (number) => <Skeleton key={number} className={classes.skeleton} animation="wave" variant="rectangular" width="100%" height={60} />,
  )}
  </Root>
);

export default ListSkeleton;
